/**
 * @desc 申请释放环保保证金
 */
import { UnfreezeApplyForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateAuctionUnfreezeEnvironmentApplyParameter = UnfreezeApplyForm

const method = 'POST'
const url = '/trade/member/unfreezeApply/auction/environment'

export const createAuctionUnfreezeEnvironmentApplyApi = (
  data?: CreateAuctionUnfreezeEnvironmentApplyParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

createAuctionUnfreezeEnvironmentApplyApi.method = method
createAuctionUnfreezeEnvironmentApplyApi.url = url
